module.exports = __webpack_public_path__ + "static/media/live17_05_2023.a5f9046f.jpg";